import React, { useMemo } from 'react';
import { AccessCodeResponse } from '../../../../../../API/order/payments/EmdAccessCodeApi';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';

interface PreviousAccessCodeAndResendProps {
  accessCodeResponse: AccessCodeResponse;
  onClick: () => void;
}

export const PreviousAccessCodeAndResend: React.FC<PreviousAccessCodeAndResendProps> = ({
  accessCodeResponse,
  onClick,
}) => {
  const humanReadableDateTimeString = useMemo(() => {
    return {
      sentAt: `${getDateString(DateFormat.smallTime, accessCodeResponse.sentAt)} ${getDateString(
        DateFormat.short,
        accessCodeResponse.sentAt
      )}`,
      depositedAt: `${getDateString(DateFormat.smallTime, accessCodeResponse.depositedAt)} ${getDateString(
        DateFormat.short,
        accessCodeResponse.depositedAt
      )}`,
    };
  }, [accessCodeResponse]);

  return (
    <>
      <button onClick={onClick} className="text-xs font-bold text-blue-900">
        Regenerate Access Code ›
      </button>
      {accessCodeResponse.depositedAt ? (
        <p className={'text-xs'}>
          Deposited by {accessCodeResponse.depositor.email} at {humanReadableDateTimeString.depositedAt}
        </p>
      ) : (
        <p className={'text-xs text-gray-600'}>
          Sent to {accessCodeResponse.depositor.email} at {humanReadableDateTimeString.sentAt}
        </p>
      )}
    </>
  );
};
